import { Pagination } from "./printer-configs";

export class OrderMaster {
    order?: Order;
    requestIdentifier?: string;
    transactionDate?: string;
    success?: boolean;
}

export class Order {
    businessUnitName?: string[];
    // tslint:disable-next-line: variable-name
    trans_uuid?: string;
    actionType?: string;
    messageType?: string;
    dataSource?: string;
    user?: string;
    userAction?: string;
    orderNumber?: string;
    externalOrderNumber?: string;
    frtFwdFacility?: string;
    salesOrderNumber?: string;
    orderType?: string;
    returnServiceLevel?: string;
    returnRMA?: string;
    aesITN?: string;
    orderDistributionType?: string;
    orderPriority?: string;
    internationalOrderDescription?: string;
    orderDate?: string;
    orderGenerationDate?: string;
    transportationStatus?: string;
    orderStatus?: string;
    shipFrom?: ShipFrom;
    customerInformation?: CustomerInformation;
    customerOrderNumber?: string;
    vendorRMA?: string;
    orderValue?: string;
    valueCurrency?: string;
    incotermName?: string;
    fillKillFlag?: boolean;
    residentialDeliveryRequired?: string;
    pickupStartDate?: string;
    pickupEndDate?: string;
    deliveryStartDate?: string;
    deliveryEndDate?: string;
    scheduledDeliveryDate?: string;
    scheduledPickupDate?: string;
    consolidationProfile?: string;
    destinationMark?: string;
    commodityCode?: string;
    orderNotes?: OrderNote[] = [];
    lines?: OrderLine[] = [];
    headerAttr?: OrderHeaderAttr[] = [];
    dsgShipVia?: string;
    shipmentReasonCode?: string;
    rtsPrefixOverrideCode?: string;
    totalUnits?: string;
    totalLines?: string;
    reasonCode?: string;
    cancel?: boolean;
    routeTo?: string;
    routeType1?: string;
    routeType2?: string;
    inventoryType?: string;
    retailerId?:string;
    errorId?: string;
    DistCtr: string;
    poType: string;
    MerchDpt: string;
    amazonRoutingNumber: string;
    department: string;
    departmentCode: string;
    merchandizingDept: string;
    merchandizingDivision: string;
    storeNumber: string;
    storeName: string;
    vendorId: string;
    storeAddress: string;
    storeAddress1: string;
    storeAddress2: string;
    storeCity: string;
    storeState: string;
    storeZip: string;
    storeCountry: string;
    proNumber: string;
    reservationNumber: string;
    giftMessage: string;
    fillKill?: boolean;
    externalPoNumber?: string;
    shelfDays?: string;
    inventoryLocks?: any;
    ufixCompletedFlag?: boolean;
}

export class OriginalAddress {
    name?: string;
    addressLine1?: string;
    addressLine2?: string;
    addressLine3?: string;
    city?: string;
    countryCode?: string;
    state?: string;
    postalCode?: string;
    countryLong?: string;
    phone?: string;
    email?: string;
    addressHasPOBox?: boolean;
    shipMethod?: string;
    trailerNumber?: string;
    vendorCode?: string;
    vendorShipToName?: string;
    rteTo?: string;
}

export class ShipFrom {
    businessUnit?: string;
    facility?: string;
    source?: string;
    companyID?: string;
    fcyId?: number;
}

export class OrderLineAttr {
    id?:string;
    key?:string;
    value?:string;
    type?:string;
}

export class OrderSerialNumber {
    itemName? : string;
    itemIndex? : number;
    serialNumberIndex? : number;
    seqNumber?:string;
    serialNumber?:string;
}

export class OrderHeaderAttr {
    id?:string;
    key?:string;
    value?:string;
    type?:string;
}


export class CustomerInformation {
    customerName?: string;
    shipTo?: ShipTo;
    billTo?: BillTo;
    originalAddress?: OriginalAddress;
    addressVerified?: boolean;
    addressValidationResult?: string;
}

export class ShipTo {
    name?: string;
    addressLine1?: string;
    addressLine2?: string;
    addressLine3?: string;
    city?: string;
    countryCode?: string;
    state?: string;
    postalCode?: string;
    phone?: string;
    email?: string;
    addressHasPOBox?: boolean;
    shipMethod?: string;
    trailerNumber?: string;
    vendorCode?: string;
    vendorShipToName?: string;
    rteTo? :string;
}


export class BillTo {
    accountNumber?: string;
    name?: string;
    addressLine1?: string;
    addressLine2?: string;
    addressLine3?: string;
    city?: string;
    countryCode?: string;
    state?: string;
    postalCode?: string;
    billingMethod?: string;
    county?: string;
    email?: string;
    fax?: string;
    phone?: string;
    frtForwardAcct?: string;
}

export class OrderNote {
    type?: any;
    code?: any;
    level?: string;
    text?: string;
    visibility?: string;
    notesProfileName?: string;
}

export class OrderLine {
    lineNumber?: string;
    item?: string;
    customerItemNumber?: string;
    value?: string;
    description?: string; // added this
    valueCurrency?: string;
    retailPrice?: string;
    orderedQuantity?: string;
    quantityUOM?: any;
    singleUnit?: string;
    serialNumbers?: SerialNumber[] = [];
    lineNotes?: LineNote[] = [];
    batchNbr?: string;
    countryOfOriginReqd?: boolean;
    batchNumberReqd?: any;
    lotRequired?: string;
    countryOfOriginRequired?: string;
    inventoryType?: string;
    itemId?: string;
    countryOfOrigin?: string;
    asnNumber?: string;
    shelfDays?: string;
    palletType?: any;
    orderLineStatus?: string;
    lineAttr?: OrderLineAttr[] = [];
    mfgDate?: string;
    crossDoc?: boolean;
    customerASNNumber: string;
    customerASNLineId: string;
    locks?: string[]=[];
    mfgRequired?: string;
    srlNbrRequired?: string;
}

export class SerialNumber {
    itemName? : string;
    itemIndex? : number;
    serialNumberIndex? : number;
    seqNumber?: any;
    serialNumber?: string;
}

export class LineNote {
    type?: string;
    code?: string;
    level?: string;
    text?: string;
    visibility?: string;
    notesProfileName?: string;
}

export class Paging {
    last?: boolean;
    first?: boolean;
    totalPages?: number;
    totalElements?: number;
    size?: number;
    number?: number;
    numberOfElements?: number;
    next?: string;
}

export class OrderSummay {
    orders: Order[];
    paging: Paging;
}

export class filterRequest {
    ordNumOrCustOrdNum: string;
    vendorRma: string;
    ordType?: string;
    orderStatus?: string;
    orderPriority?: string;
    orderAttributes?: any[]| string;
    exactOrderType?: string;
    waveId?: string;
    fromDate?: string;
    toDate?: string;
    pageNumber?: string;
    uFixCompleted?: boolean;
}

export class filterRTVRequest {
    ordNumOrCustOrdNum: string;
    vendorRma: string;
    ordType?: string;
    orderStatus?: string;
    exactOrderType?: string;
    waveId?: string;
    fromDate?: string;
    toDate?: string;
}

export class OrderSearch {
    cusId: string;
    pageNumber: string;
    ordNumOrCustOrdNum: string;
    vendorRma: string;
    ordType?: string;
    orderStatus?: string;
    orderPriority?: string;
    orderAttributes?: any[] | string;
    exactOrderType?: string;
    waveId?: string;
    fromDate?: string;
    toDate?: string;
    responseFilter?: string;
    buId?: string;
    fcyId?: string;
    uFixCompleted?: boolean;
}

export class InventoryParam {
    custId: string;
    buId: string;
    fcyId: string;
}

export class InventoryAllocationConfigResponse{
    requestIdentifier: string;
    transactionDate: string;
    success: boolean;
    invAllocConfigs: invAllocConfigs[];
}

export class invAllocConfigs{
    invAllocConfigId: string;
    custId: string;
    buId: string;
    fcyId: string;
    allocationName: string;
    creationDate: string;
    createdBy: string;
    lastUpdateDate: string;
    lastUpdatedBy: string;
}

export class OrderErrorResponse {
    requestIdentifier: string;
    transactionDate: string;
    success: boolean;
    orderErrorId: number;
    buid: number;
    fcyId: number;
    orderJson: string;
    errors: Error;
  }

  export class Error{
    code: string;
    errorMessage: string;
  }
  export class OrderConsolidationSearchParams{
     custId : number;
	 buId : number;
	 fcyId : number;
	 serviceLevel : string;
	 orderNumber : string[] | string;
	 carrierCode : string;
	 shiptoPostalcode :  string[] | string;
	 shiptoCity :  string[] | string;
	 shiptoState : string;
	 orderType : string;
  }

  export class OrderConsolidationResponse{
    orderNumber : string;
	orderLineDetails : OrderLineDetails[];
  }

  export class OrderLineDetails{

     orderLineId : number;
     orderId: number;
     orderNumber : string;
     customerOrderNumber : string;
	 itemCode : string;
	 itemId : string;
	 lineNumber : string;
	 quantity : number;
	 qtyUom : string;
	 lineWeight : number;
	 lineVolume : number;
	 availableToPromise : number;
     checked?: boolean ;

  }
  
  export class OrderConsolidationResponseList{
  requestIdentifier: string;
  transactionDate: string ;
  success : boolean;
  orderConsolidation : OrderConsolidationResponse[];
  paging : Pagination
  }


  export class PicklistRequest{

    buId: number;
    fcyId: number;
    custId : number;
    picklist : Picklist[];
    packStation : string;
    totalUnits : number;
    picklistVolume : number;
    picklistWeight : number;

  }

  export class Picklist{
    
    orderNumber : string;
    itemId: number;
    itemCode: string;
    orderQuantity: number;
    orderId: number;
    orderLineId: number
    
  }


 export class PickListResponse{
  requestIdentifier : string;
  transactionDate : string;
  success : boolean;
  message : string;
  generatePickList : boolean;
  paging: Paging;
}

export class PutListRequest{
   asnId:string;
   packStation:string;
  }

  export class PutListResponse{
    requestIdentifier : string;
    transactionDate : string;
    status : boolean;
    responseMessage : string;
  }
export class PicklistInquiryRequest{
    picklistNumber : string;
    fcyId : number;
    custId : number;
    buId : number;
    picklistStatuses : string[];
    orderNumber : string;
    itemCode : string;
    fromDate : string;
    toDate : string;
    responseFilter : string;
    pageLimit : string;
    page : string; 
}
  
export class PicklistInquiryResponse {
    requestIdentifier : string;
	transactionDate : string;
	success : boolean;
	errors  : Error;
	pickListHeaderObjList : PickListHeader[];
	paging : Paging;
  
}

export class PickListHeader{
   pickListHeaderId : number;
   pickListNumber : string;
   custId : number;
	fcyId : number;
	buId : number;
	packStationNumber : string;
	active : string;
	createdBy : string;
	createdDate : string;
	pickListLines :PickListLineObj[] ;
	pickedListLines : PickedListLineObj[]   ;
}

export class PickListLineObj{
    pickListLineId : number;
	pickListLineNumber : string;
	custId : number;
	fcyId : number;
	buId : number;
	itemId : number;
	itemCode : string;
	orderId : number;
	orderNumber : string;
	orderQty : number;
	orderLineId : number;
	suggestedPickQty : number;
	suggestedPickUom : string;
	suggestedPickLocation : string;
	createdBy : string;
	createdDate : string;
}

export class PickedListLineObj{
         pickListLineId : number;
         custId : number;
         fcyId : number;
         buId : number;
         itemId : number;
         pickedQty : number;
         pickedLocation : string;
         pickedQtyUom : string;
         createdBy : string;
         createdDate : string;
         pickedBy : string;
         pickedDttm : string;
}

export class PrintPicklistResponse{

	responseMessage : string;
	status : boolean;
	errorCode : string;
	errorDescription : string;
	requestIdentifier : string;
    success: boolean;
}

export class PrintPicklistRequest{
    pickListNumber: string;
    packStation : string;
}